import { setupPendo, PendoUser } from '@/common/application/utils/pendoInit';

type LoginData = {
  userName?: string;
  UserName?: string;
  UserID?: number | string;
  userID?: number | string;
  UserId?: number | string;
  Email?: string;
  email?: string;
  FirstName?: string;
  firstName?: string;
  LastName?: string;
  lastName?: string;
};

type StoredClient = {
  id?: number | string;
  globalUserMappingID?: number | string;
  name?: string;
  clientName?: string;
  CompanyName?: string;
  companyName?: string;
};

const readJson = <T,>(key: string): T | null => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
};

/**
 * Customer Portal auth uses an RCA session GUID (`Authorization: rca {guid}`), not a JWT.
 * Visitor/account identity therefore comes from loginData + selectedClient in localStorage.
 */
export const getPendoIdentityFromStorage = (): PendoUser | null => {
  const loginData = readJson<LoginData>('loginData');
  if (!loginData) return null;

  const userId = loginData.UserID ?? loginData.userID ?? loginData.UserId;
  const userName = loginData.userName ?? loginData.UserName;
  if (userId == null && !userName) return null;

  const visitorId = String(userId ?? userName);
  const firstName = loginData.FirstName ?? loginData.firstName;
  const lastName = loginData.LastName ?? loginData.lastName;
  const full_name = [firstName, lastName].filter(Boolean).join(' ') || userName;

  const client = readJson<StoredClient>('selectedClient');
  const mappingId = client?.globalUserMappingID;
  const clientId = client?.id;
  const accountId =
    mappingId != null ? String(mappingId) : clientId != null ? String(clientId) : `global-user-${visitorId}`;
  const accountName =
    client?.name ?? client?.clientName ?? client?.CompanyName ?? client?.companyName ?? userName;

  return {
    id: visitorId,
    email: loginData.Email ?? loginData.email,
    full_name,
    accountId,
    accountName,
  };
};

/** Initialize (or re-initialize) Pendo from the current portal session storage. */
export const initPendoFromSession = (): void => {
  try {
    const identity = getPendoIdentityFromStorage();
    const apiKey = import.meta.env.VITE_PENDO_KEY as string | undefined;
    if (!identity || !apiKey) return;
    setupPendo(identity, apiKey);
  } catch {
    // Non-critical: analytics must not block auth.
  }
};
